// src/NotFoundPage/NotFoundPage.tsx
import * as React from "react";
import Box from "@cloudscape-design/components/box";
import Link from "@cloudscape-design/components/link";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Header from "@cloudscape-design/components/header";
import TextContent from "@cloudscape-design/components/text-content";

// src/NotFoundPage/NotFoundIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var NotFoundIllustration = () => {
  return /* @__PURE__ */ jsxs("svg", { width: "620", height: "348", viewBox: "0 0 620 348", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-testid": "page-not-found-illustration", children: [
    /* @__PURE__ */ jsx("path", { d: "M539.75 256.3H91.25C91.6896 133.452 191.921 34 315.5 34C439.079 34 539.31 133.452 539.75 256.3Z", fill: "#D3E7F9" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M286.205 275.534L302.885 246.644L308.282 249.76L291.602 278.651L286.205 275.534Z",
        fill: "#F4F4F4",
        stroke: "#000716",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M314.126 233.759C318.728 225.787 321.129 218.556 319.488 217.609C317.847 216.661 312.785 222.356 308.183 230.328C303.58 238.299 301.179 245.53 302.82 246.478C304.462 247.425 309.523 241.731 314.126 233.759Z",
        fill: "#F4F4F4",
        stroke: "#000716",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M308.067 249.507L302.822 246.478C304.463 247.426 309.523 241.734 314.127 233.759C318.731 225.785 321.13 218.557 319.489 217.609L324.74 220.641C326.381 221.588 323.981 228.817 319.377 236.791C314.774 244.765 309.713 250.457 308.072 249.51",
        fill: "#F4F4F4"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M308.067 249.507L302.822 246.478C304.463 247.426 309.523 241.734 314.127 233.759C318.731 225.785 321.13 218.557 319.489 217.609L324.74 220.641C326.381 221.588 323.981 228.817 319.377 236.791C314.774 244.765 309.713 250.457 308.072 249.51",
        stroke: "#000716",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "rect",
      {
        x: "235.316",
        y: "202.472",
        width: "16.7438",
        height: "28.0864",
        rx: "1",
        transform: "rotate(45 235.316 202.472)",
        fill: "#F4F4F4",
        stroke: "#000716",
        strokeWidth: "2",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M223.995 213.913L241.087 219.701L246.052 214.736L234.612 203.296L223.995 213.913Z", fill: "#000716" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M108.769 183.688C110.996 182.402 111.759 179.551 110.473 177.323C109.186 175.095 106.336 174.331 104.109 175.616C101.882 176.902 101.119 179.753 102.405 181.981C103.691 184.209 106.542 184.974 108.769 183.688Z",
        fill: "#0972D3",
        stroke: "#000716",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M109.052 183.988L129.577 219.538", stroke: "#000716", strokeWidth: "2", strokeLinecap: "square" }),
    /* @__PURE__ */ jsx("line", { x1: "95.2935", y1: "160.748", x2: "101.235", y2: "171.039", stroke: "#000716", strokeWidth: "2" }),
    /* @__PURE__ */ jsx("line", { x1: "110.011", y1: "157.899", x2: "106.935", y2: "169.377", stroke: "#000716", strokeWidth: "2" }),
    /* @__PURE__ */ jsx("line", { x1: "84.9912", y1: "172.116", x2: "96.4691", y2: "175.192", stroke: "#000716", strokeWidth: "2" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M125.902 259.19L115.612 253.248L98.8677 282.249L109.158 288.191L125.902 259.19Z",
        fill: "#D1D5DB",
        stroke: "#000716",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M125.909 259.19L115.619 253.248L110.473 262.161L120.763 268.103L125.909 259.19Z", fill: "#000716" }),
    /* @__PURE__ */ jsx("line", { x1: "107.469", y1: "269.099", x2: "117.76", y2: "275.04", stroke: "#000716", strokeWidth: "2" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M99.4077 281.316L115.333 290.51C119.501 292.917 121.013 298.139 118.683 302.175L117.382 304.428L93.8934 290.867L99.4029 281.324L99.4077 281.316Z",
        fill: "#F4F4F4",
        stroke: "#000716",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M133.182 246.318H121.3L139.124 293.848H151.006L133.182 246.318Z",
        fill: "#D1D5DB",
        stroke: "#000716",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx("line", { x1: "133.182", y1: "277.725", x2: "145.065", y2: "277.725", stroke: "#000716", strokeWidth: "2" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M139.124 293.848H157.513C162.326 293.848 166.246 297.615 166.246 302.275V304.877H139.124V293.858V293.848Z",
        fill: "#F4F4F4",
        stroke: "#000716",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M215.821 246.318H227.704L209.88 293.848H197.997L215.821 246.318Z",
        fill: "#D1D5DB",
        stroke: "#000716",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx("line", { x1: "204.479", y1: "274.484", x2: "216.361", y2: "274.484", stroke: "#000716", strokeWidth: "2" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M197.997 293.848H216.386C221.199 293.848 225.12 297.615 225.12 302.275V304.877H197.997V293.858V293.848Z",
        fill: "#F4F4F4",
        stroke: "#000716",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M211.276 258.957H211.238L215.705 247.104H227.704L225.7 252.221H225.813L221.171 264.073H209.347L211.276 258.957Z",
        fill: "#000716"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M293.568 264.769C296.507 263.991 299.525 265.737 300.312 268.675C301.1 271.618 299.354 274.642 296.411 275.431L279.715 279.905L276.863 269.261C283.635 267.403 287.903 266.269 293.568 264.769Z",
        fill: "#F4F4F4",
        stroke: "#000716",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M293.568 264.769C296.507 263.991 299.525 265.737 300.312 268.675C301.1 271.618 299.354 274.642 296.411 275.431L279.715 279.905L276.863 269.261C283.635 267.403 287.903 266.269 293.568 264.769Z",
        fill: "#F4F4F4",
        stroke: "#000716",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M249.309 278.455C234.185 273.594 227.164 262.251 227.164 262.251L235.806 254.689C235.806 254.689 242.77 263.629 254.17 267.652C263.352 270.893 276.855 269.273 276.855 269.273L279.772 279.892C279.772 279.892 264.432 283.316 249.309 278.455Z",
        fill: "#D1D5DB",
        stroke: "#000716",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx("line", { x1: "251.499", y1: "279.818", x2: "254.555", y2: "268.335", stroke: "#000716", strokeWidth: "2" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M118.643 227.135C120.439 217.661 124.602 209.022 138.841 208.779L213.004 209.692C225 210.07 231.872 218.661 232.095 231.775L232.309 244.346C232.425 251.413 227.437 257.296 220.982 257.713L126.689 259.88C118.978 260.057 113.123 252.988 114.734 245.445L118.643 227.135Z",
        fill: "#F4F4F4",
        stroke: "#000716",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M132.299 265.366C144.933 265.366 155.181 255.114 155.181 242.474C155.181 229.834 144.933 219.582 132.299 219.582C119.664 219.582 109.417 229.834 109.417 242.474C109.417 255.114 119.664 265.366 132.299 265.366Z",
        fill: "#D1D5DB",
        stroke: "#000716",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M132.299 247.551C135.104 247.551 137.384 245.27 137.384 242.464C137.384 239.658 135.104 237.377 132.299 237.377C129.495 237.377 127.214 239.658 127.214 242.464C127.214 245.27 129.495 247.551 132.299 247.551Z",
        fill: "#0972D3",
        stroke: "#000716",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M225.543 264.142C232.999 264.142 239.046 258.518 239.046 251.584C239.046 244.65 232.999 239.026 225.543 239.026C218.088 239.026 212.04 244.65 212.04 251.584C212.04 258.518 218.088 264.142 225.543 264.142Z",
        fill: "#000716"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M226.249 262.999C232.567 262.999 237.69 257.872 237.69 251.552C237.69 245.232 232.567 240.106 226.249 240.106C219.932 240.106 214.808 245.232 214.808 251.552C214.808 257.872 219.932 262.999 226.249 262.999Z",
        fill: "#D1D5DB",
        stroke: "#000716",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M290.691 232.187C289.565 233.327 287.739 233.354 286.586 232.229L266.71 217.981L264.026 220.72L281.383 237.706C282.426 238.736 282.454 240.424 281.424 241.481L280.69 242.216C279.564 243.355 277.738 243.383 276.585 242.257L251.103 217.31L250.54 216.747L233.416 199.116C232.277 197.99 232.25 196.164 233.376 195.011L253.687 174.702C256.421 171.969 260.853 171.969 263.586 174.703L301.845 212.962C303.959 215.048 303.993 218.432 301.927 220.553L290.691 232.187Z",
        fill: "#F4F4F4",
        stroke: "#000716",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M247.456 171.3C250.971 167.786 256.67 167.786 260.184 171.3L275.208 186.324L243.777 217.755C242.996 218.536 241.729 218.536 240.948 217.755L227.339 204.146C223.824 200.631 223.824 194.933 227.339 191.418L247.456 171.3Z",
        fill: "#D1D5DB",
        stroke: "#000716",
        strokeWidth: "2",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M273.797 203.314C274.758 204.936 276.855 205.472 278.477 204.511C280.099 203.55 280.636 201.454 279.675 199.832C278.714 198.209 276.618 197.673 274.996 198.634C273.373 199.595 272.836 201.691 273.797 203.314Z",
        fill: "#0972D3",
        stroke: "#000716",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M297.714 208.83L297.819 225.392L302.512 220.699C304.465 218.746 304.465 215.581 302.512 213.628L297.714 208.83Z", fill: "#000716" }),
    /* @__PURE__ */ jsx("path", { d: "M93.2129 304.921L258.491 304.921", stroke: "#000716", strokeWidth: "2", strokeLinecap: "square", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsx("path", { d: "M225.021 199.626L225.526 201.674L263.332 197.58L264.393 195.41L225.021 199.626Z", fill: "#000716" }),
    /* @__PURE__ */ jsx("path", { d: "M228.289 199.217L228.794 201.265L263.784 197.674L264.339 194.977L228.289 199.217Z", fill: "#000716" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M275.019 173.959C274.67 173.649 274.429 173.251 274.328 172.798C273.374 168.842 269.73 148.371 249.668 150.585C229.055 152.857 230.231 174.064 230.876 178.487C230.946 178.994 230.853 179.514 230.587 179.959L220.746 196.609C219.799 198.206 221.081 200.193 222.927 200.003L290.53 192.777C292.473 192.564 293.25 190.148 291.791 188.844L275.008 173.948L275.019 173.959Z",
        fill: "#EC7211",
        stroke: "#000716",
        strokeWidth: "2",
        strokeLinecap: "round"
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M231.002 179.265L274.521 173.932", stroke: "#000716", strokeWidth: "2", strokeLinecap: "round" }),
    /* @__PURE__ */ jsx("path", { d: "M250.041 150.03L253.044 145.25", stroke: "#000716", strokeWidth: "2", strokeLinecap: "round" }),
    /* @__PURE__ */ jsx("path", { d: "M249.566 150.067L245.854 145.812", stroke: "#000716", strokeWidth: "2", strokeLinecap: "round" }),
    /* @__PURE__ */ jsx("path", { d: "M249.572 150.779C245.57 151.507 239.782 162.352 241.429 177.245", stroke: "#000716", strokeWidth: "2", strokeLinecap: "round" }),
    /* @__PURE__ */ jsx("path", { d: "M250.544 150.705C254.618 150.797 261.973 160.053 262.671 175.031", stroke: "#000716", strokeWidth: "2", strokeLinecap: "round" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M469.889 298.708C469.633 297.855 469.332 297.637 468.747 297.119C467.888 296.203 468.021 294.905 470.315 294.351C471.368 294.097 472.661 294.088 474.016 294.151C476.052 294.251 477.841 294.623 479.559 295.095C481.533 295.631 483.41 296.212 484.862 296.929C487.368 298.163 487.837 299.842 485.5 300.859C484.632 301.24 483.844 301.64 482.932 302.003C481.914 302.411 480.612 302.683 478.992 302.801C475.53 303.056 472.608 302.257 471.218 301.295C469.73 300.269 470.04 299.143 469.907 298.69L469.889 298.708Z",
        fill: "#9BA7B6"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M489.689 298.553C489.379 297.854 489.804 297.192 491.575 296.783C492.921 296.475 494.913 296.547 496.498 296.938C499.854 297.773 500.837 299.461 498.482 300.323C496.967 300.877 494.293 300.823 492.301 300.205C490.902 299.77 490.096 299.252 489.698 298.553H489.689Z",
        fill: "#9BA7B6"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M481.437 293.843C481.1 293.216 481.437 292.69 482.606 292.3C483.863 291.882 485.961 291.9 487.653 292.336C490.707 293.126 491.495 294.669 489.229 295.431C487.865 295.894 485.528 295.822 483.739 295.268C482.446 294.868 481.72 294.387 481.428 293.843H481.437Z",
        fill: "#9BA7B6"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M494.65 303.128C495.031 303.818 494.659 304.363 493.463 304.753C491.852 305.279 489.107 305.08 487.301 304.335C485.362 303.537 485.034 302.438 486.522 301.748C487.814 301.149 490.391 301.158 492.33 301.767C493.596 302.157 494.367 302.629 494.65 303.128Z",
        fill: "#9BA7B6"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M419.889 310.664C419.633 309.811 419.332 309.593 418.747 309.076C417.888 308.159 418.021 306.861 420.315 306.307C421.368 306.053 422.661 306.044 424.016 306.108C426.052 306.208 427.841 306.58 429.559 307.052C431.533 307.587 433.41 308.168 434.862 308.885C437.368 310.12 437.837 311.799 435.5 312.816C434.632 313.197 433.844 313.596 432.932 313.959C431.914 314.368 430.612 314.64 428.992 314.758C425.53 315.012 422.608 314.213 421.218 313.251C419.73 312.226 420.04 311.1 419.907 310.646L419.889 310.664Z",
        fill: "#9BA7B6"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M439.689 310.51C439.379 309.811 439.804 309.148 441.575 308.74C442.921 308.431 444.913 308.504 446.498 308.894C449.854 309.729 450.837 311.418 448.482 312.28C446.967 312.834 444.293 312.779 442.301 312.162C440.902 311.726 440.096 311.209 439.698 310.51H439.689Z",
        fill: "#9BA7B6"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M431.437 305.799C431.1 305.173 431.437 304.647 432.606 304.256C433.863 303.839 435.961 303.857 437.653 304.293C440.707 305.082 441.495 306.625 439.229 307.388C437.865 307.851 435.528 307.778 433.739 307.224C432.446 306.825 431.72 306.344 431.428 305.799H431.437Z",
        fill: "#9BA7B6"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M444.65 315.085C445.031 315.774 444.659 316.319 443.463 316.709C441.852 317.236 439.107 317.036 437.301 316.292C435.362 315.493 435.034 314.395 436.522 313.705C437.814 313.106 440.391 313.115 442.33 313.723C443.596 314.113 444.367 314.585 444.65 315.085Z",
        fill: "#9BA7B6"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M369.889 298.708C369.633 297.855 369.332 297.637 368.747 297.119C367.888 296.203 368.021 294.905 370.315 294.351C371.368 294.097 372.661 294.088 374.016 294.151C376.052 294.251 377.841 294.623 379.559 295.095C381.533 295.631 383.41 296.212 384.862 296.929C387.368 298.163 387.837 299.842 385.5 300.859C384.632 301.24 383.844 301.64 382.932 302.003C381.914 302.411 380.612 302.683 378.992 302.801C375.53 303.056 372.608 302.257 371.218 301.295C369.73 300.269 370.04 299.143 369.907 298.69L369.889 298.708Z",
        fill: "#9BA7B6"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M389.689 298.553C389.379 297.854 389.804 297.192 391.575 296.783C392.921 296.475 394.913 296.547 396.498 296.938C399.854 297.773 400.837 299.461 398.482 300.323C396.967 300.877 394.293 300.823 392.301 300.205C390.902 299.77 390.096 299.252 389.698 298.553H389.689Z",
        fill: "#9BA7B6"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M381.437 293.843C381.1 293.216 381.437 292.69 382.606 292.3C383.863 291.882 385.961 291.9 387.653 292.336C390.707 293.126 391.495 294.669 389.229 295.431C387.865 295.894 385.528 295.822 383.739 295.268C382.446 294.868 381.72 294.387 381.428 293.843H381.437Z",
        fill: "#9BA7B6"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M394.645 303.128C395.026 303.818 394.654 304.363 393.459 304.753C391.847 305.279 389.102 305.08 387.296 304.335C385.357 303.537 385.029 302.438 386.517 301.748C387.809 301.149 390.386 301.158 392.325 301.767C393.591 302.157 394.362 302.629 394.645 303.128Z",
        fill: "#9BA7B6"
      }
    )
  ] });
};

// ../../tool-configs/awsmp-max-monitoring-frontend/lib/metrics-constants.js
var CustomOpsMetricName;
(function(CustomOpsMetricName2) {
  CustomOpsMetricName2["ClientSide404"] = "ClientSide404";
  CustomOpsMetricName2["ClientSide500"] = "ClientSide500";
  CustomOpsMetricName2["ClientSide500Ignored"] = "ClientSide500Ignored";
  CustomOpsMetricName2["ClientSideNonFatalToolCallError"] = "ClientSideNonFatalToolCallError";
  CustomOpsMetricName2["EPOBuyerUnonboardedPageRender"] = "EPOBuyerUnonboardedPageRender";
})(CustomOpsMetricName || (CustomOpsMetricName = {}));
var CustomOpsSdkServiceName;
(function(CustomOpsSdkServiceName2) {
  CustomOpsSdkServiceName2["MARKETPLACE_DISCOVERY"] = "MarketplaceDiscovery";
  CustomOpsSdkServiceName2["MARKETPLACE_AGREEMENT"] = "MarketplaceAgreement";
  CustomOpsSdkServiceName2["MARKETPLACE_CATALOG"] = "MarketplaceCatalog";
})(CustomOpsSdkServiceName || (CustomOpsSdkServiceName = {}));

// ../../tool-configs/awsmp-max-monitoring-frontend/lib/sdk-metrics/types.js
var STATUS_CODE_CLASS;
(function(STATUS_CODE_CLASS2) {
  STATUS_CODE_CLASS2["TWO_HUNDRED"] = "200";
  STATUS_CODE_CLASS2["FOUR_HUNDRED"] = "400";
  STATUS_CODE_CLASS2["FIVE_HUNDRED"] = "500";
})(STATUS_CODE_CLASS || (STATUS_CODE_CLASS = {}));

// src/NotFoundPage/NotFoundPage.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var NotFoundPage = ({ logger }) => {
  React.useEffect(() => {
    logger.opsMetric({
      metricName: CustomOpsMetricName.ClientSide404,
      unit: "Count",
      value: 1
    });
  }, []);
  return /* @__PURE__ */ jsx2("div", { "data-testid": "not-found-page", style: { display: "flex", justifyContent: "center", width: "100%", minHeight: "50vh", alignItems: "center" }, children: /* @__PURE__ */ jsx2(Box, { padding: "xl", children: /* @__PURE__ */ jsxs2(SpaceBetween, { size: "s", direction: "vertical", alignItems: "start", children: [
    /* @__PURE__ */ jsx2(Box, { children: /* @__PURE__ */ jsx2(NotFoundIllustration, {}) }),
    /* @__PURE__ */ jsx2(Header, { variant: "h1", children: "Page not found" }),
    /* @__PURE__ */ jsx2(TextContent, { children: "The page you are looking for does not exist or the project has been deleted." }),
    /* @__PURE__ */ jsxs2(TextContent, { children: [
      /* @__PURE__ */ jsx2("p", { children: /* @__PURE__ */ jsx2(Link, { variant: "primary", href: "/", children: "Agent Mode" }) }),
      /* @__PURE__ */ jsx2("p", { children: /* @__PURE__ */ jsx2(Link, { variant: "primary", href: "https://aws.amazon.com/marketplace/", children: "AWS Marketplace Home" }) }),
      /* @__PURE__ */ jsx2("p", { children: /* @__PURE__ */ jsx2(Link, { variant: "primary", href: "https://aws.amazon.com/marketplace/help/contact-us", children: "Contact AWS Marketplace" }) })
    ] })
  ] }) }) });
};
export {
  NotFoundPage
};
//# sourceMappingURL=index.js.map
